/** QR ของเครื่อง: `CAPTAG:1:MACHINE:<plant>:<machine_code>` — รับเฉพาะ payload เต็มจากเครื่องสแกน ไม่รับรหัสที่พิมพ์ */

const MACHINE_QR_PATTERN = /^CAPTAG:1:MACHINE:([^:\s]+):([^:\s]+)$/;

export type MachineQrParse =
  | { readonly ok: true; readonly raw: string; readonly plantCode: string; readonly machineCode: string }
  | { readonly ok: false; readonly message: string };

export const MACHINE_SCAN_REQUIRED_TEXT = 'ต้องสแกน QR ที่เครื่อง';

export function parseMachineQr(input: string): MachineQrParse {
  const raw = input.trim();
  const match = MACHINE_QR_PATTERN.exec(raw);
  if (match === null) {
    return {
      ok: false,
      message: raw.startsWith('CAPTAG:')
        ? 'QR นี้ไม่ใช่ QR ของเครื่อง — สแกน QR ที่ติดบนเครื่อง'
        : MACHINE_SCAN_REQUIRED_TEXT,
    };
  }
  return { ok: true, raw, plantCode: match[1] as string, machineCode: match[2] as string };
}
